module.exports = __webpack_public_path__ + "static/media/bg-home_mobile.e9fcc252.jpg";